<script>
import LayerPersonChooser from '@/layer/components/LayerPersonChooser.vue';
import EggStockTypeQuantityInput from '@/layer/components/EggStockTypeQuantityInput.vue';

export default {
  components: {
    LayerPersonChooser,
    EggStockTypeQuantityInput,
  },

  data: () => ({
    person: '',
    types: [],
  }),

  computed: {
    validationError() {
      if (!this.person) return 'Please choose a Person';
      if (!this.types.find(x => x.count > 0)) return 'Please fill in at least one of the Types';

      return undefined;
    },

    submitPayload() {
      let quantityPerTypeId = {};
      this.types.filter(x => x.count > 0).forEach(x => { quantityPerTypeId[x.id] = x.count });

      return {
        person: this.person,
        types: quantityPerTypeId,
      };
    },
  },

  methods: {
    onStockTypesLoaded(types) {
      types.forEach(x => { x.count = 0; });
      this.types = types;
    },

    clearForm() {
      this.person = '';
      this.types.forEach(x => { x.count = 0 });
    },

    onFormSubmitSuccess(addedStock) {
      this.clearForm();
    },

    onCancelledForm() {
      this.$router.push({ name: 'form-cancelled' });
    },
  },
}
</script>

<template>

  <b-card>
    <api-form
      method="post"
      url="v1/layers/packed-stock-in"
      :payload="submitPayload"
      submit-text="Add"
      :validation-error="validationError"
      :make-success-message="() => `Stock In record was successfully added.`"
      @success="onFormSubmitSuccess"
      @cancel="onCancelledForm">

      <slot name="above-header"></slot>

      <h4 class="text-center mt-0">Add Stock In</h4>

      <layer-person-chooser v-model="person" required />

      <div v-if="person">
        <b-form-group v-if="types">

          <div v-for="typ in types" :key="typ.id" class="mt-4">
            <egg-stock-type-quantity-input
              v-model="typ.count"
              :type-name="typ.type"
              :unit="typ.unit"
              :quantity-per-box="typ.quantity_per_box" />
          </div>

        </b-form-group>

        <div class="mt-4"></div>
      </div>

      <api-loader
        v-if="person"
        method="get"
        url="v1/layers/egg-stock-types"
        @loaded="onStockTypesLoaded" />

    </api-form>

  </b-card>
</template>



// WEBPACK FOOTER //
// src/layer/components/EggStockAddStockIn.vue